import { z } from 'zod';

export const DeepLinkData = z.object({
  storyId: z.string().optional(),
  marketingSegmentId: z.string().optional(),
});

export type DeepLinkData = z.infer<typeof DeepLinkData>;
